module.exports = __webpack_public_path__ + "assets/img/slat_close5.ad9ef19a.svg";